import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './LandingPage.css';
import './PoliticaPrivacidade.css';
import './ManualUso.css';
import logo from './assets/logo.png';
import printLogin from './assets/printlogin.jpeg';
import painelAgente from './assets/painelagente.jpeg';
import pendencias from './assets/pendenciasdomunicipio.jpeg';
import triagem from './assets/triagem.jpeg';
import atender1 from './assets/atendendoadenuncia.jpeg';
import atender2 from './assets/atendendoadenuncia2.jpeg';
import registro1 from './assets/registroproativo.jpeg';
import registro2 from './assets/registroproativo2.jpeg';
import historico from './assets/historico.jpeg';
import mapa from './assets/mapa.jpeg';
import mapa2 from './assets/mapa2.jpeg';
import telaPerfil from './assets/telaperfil.jpeg';
import permissoes from './assets/permissões.jpeg';
import loginPainelWeb from './assets/loginpainelweb.png';
import gerenciamentoPainel from './assets/gereciamentopainelweb.png';
import vigilanciaEnto from './assets/vigilanciaentomologica.png';
import processarFicha from './assets/processar.png';
import cadastrarExame from './assets/cadastrar.png';
import modalExame from './assets/modalexame.png';
import mapaVigilancia from './assets/mapadevigilancia.png';

const ManualUso = () => {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const offset = 120; // Espaço para não ficar colado no topo
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = element.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div className="landing-page" style={{ background: '#fff', minHeight: '100vh', padding: '0' }}>
            
            {/* CABEÇALHO/BANNER */}
            <div className="manual-hero-banner">
                <div className="manual-hero-overlay">
                    <button
                        className="back-home-button-modern"
                        onClick={() => navigate('/')}
                    >
                        <div className="back-button-circle">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <span className="back-button-text">Voltar para a Home</span>
                    </button>
                    
                    <div className="manual-hero-content">
                        <h1 className="manual-hero-title">Manual de Uso Técnico</h1>
                        <p className="manual-hero-subtitle">Guia para utilização do sistema Vector Tracker</p>
                    </div>
                </div>
            </div>

            {/* MINI SUMÁRIO */}
            <div className="manual-mini-summary">
                <button onClick={() => scrollToSection('sobre-aplicativo-sec')} className="summary-btn">
                    Sobre o Aplicativo
                </button>
                <span className="summary-separator">•</span>
                <button onClick={() => scrollToSection('sobre-painel-web-sec')} className="summary-btn">
                    Sobre o Painel Web
                </button>
            </div>

            <div className="manual-container">
                {/* SEÇÃO: SOBRE O APLICATIVO */}
                <div id="sobre-aplicativo-sec" className="manual-main-section-title">
                    <h2>SOBRE O APLICATIVO</h2>
                    <div className="title-underline"></div>
                </div>

                {/* SEÇÃO 1: LOGIN E CADASTRO */}
                <div className="manual-section-row">
                    <div className="manual-text-content">
                        <h2 className="manual-section-title">1. Acesso ao Sistema e Cadastro</h2>
                        <div className="manual-important-box">
                            <strong>⚠️ IMPORTANTE:</strong> A tela de login exige conexão com a internet para validar seu usuário no banco de dados.
                        </div>
                        <ul className="manual-list">
                            <li><strong>Uso em Campo (Offline):</strong> Antes de se deslocar para áreas sem sinal, certifique-se de que já realizou o login.</li>
                            <li><strong>Sessão Ativa:</strong> Logado, o aplicativo manterá sua sessão ativa, permitindo trabalhar normalmente mesmo sem internet.</li>
                            <li>
                                O cadastro dos ACEs não é realizado pelo aplicativo. A criação de contas é feita exclusivamente através do <a href="https://painel.vectortrackers.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#00AEEF', fontWeight: 'bold', textDecoration: 'underline' }}>Painel Web</a>. Com acesso ao painel é possível cadastrar ou editar as informações dos agentes.
                            </li>
                        </ul>
                    </div>
                    <div className="manual-image-content">
                        <img src={printLogin} alt="Tela de Login" className="manual-screenshot" />
                    </div>
                </div>

                {/* SEÇÃO 2: PAINEL DO AGENTE */}
                <div className="manual-section-row reverse">
                    <div className="manual-text-content">
                        <h2 className="manual-section-title">2. Visão Geral do Painel do Agente</h2>
                        <p>Ao fazer login como Agente, terá acesso a aba <strong>Painel do Agente</strong>, que centraliza as principais ações:</p>
                        <ul className="manual-list">
                            <li><strong>Pendências do Município:</strong> Lista de denúncias enviadas pelos cidadãos que aguardam vistoria.</li>
                            <li><strong>Novo Registro Proativo:</strong> Início de uma visita de campo que não se originou de uma denúncia (vigilância ativa).</li>
                            <li><strong>Meu Trabalho:</strong> Histórico de todos os registros e vistorias concluídos.</li>
                            <li><strong>Mapa da Área:</strong> Visualização geográfica das denúncias e focos no município.</li>
                            <li><strong>Sincronizar Dados:</strong> Gerenciamento de registros feitos sem internet (offline) que aguardam envio.</li>
                            <li><strong>Perfil do Agente:</strong> acesso a políticas de privacidade e configurações.</li>
                        </ul>
                    </div>
                    <div className="manual-image-content">
                        <img src={painelAgente} alt="Painel do Agente" className="manual-screenshot" />
                    </div>
                </div>

                {/* SEÇÃO 3: ATENDIMENTO DE DENÚNCIAS */}
                <div className="manual-section-row">
                    <div className="manual-text-content">
                        <h2 className="manual-section-title">3. Atendimento de Denúncias</h2>
                        <p>Em <strong>Pendências do Município</strong> ficam as denúncias enviadas pela comunidade. Ao acessar uma denúncia, o agente pode:</p>
                        <ul className="manual-list">
                            <li><strong>Analisar a Foto:</strong> Verificar a imagem enviada pelo cidadão para triagem inicial.</li>
                            <li><strong>Atender:</strong> Iniciar a vistoria preenchendo o formulário completo com as informações técnicas.</li>
                            <li><strong>Recusar:</strong> Caso a denúncia não seja pertinente, é possível descartá-la e enviar uma mensagem de feedback ao cidadão.</li>
                        </ul>
                    </div>
                    <div className="manual-image-content">
                        <div className="manual-image-grid">
                            <img src={pendencias} alt="Pendências" className="grid-screenshot" />
                            <img src={triagem} alt="Triagem" className="grid-screenshot" />
                            <img src={atender1} alt="Atendimento 1" className="grid-screenshot" />
                            <img src={atender2} alt="Atendimento 2" className="grid-screenshot" />
                        </div>
                    </div>
                </div>

                {/* SEÇÃO 4: NOVO REGISTRO PROATIVO EL FORMULÁRIO */}
                <div className="manual-section-row reverse">
                    <div className="manual-text-content">
                        <h2 className="manual-section-title">4. Novo Registro Proativo e Formulário</h2>
                        <p>
                            O Formulário de Campo disponível no aplicativo Vector Tracker foi desenvolvido com base no modelo de ficha utilizado pelos sistemas oficiais de registro de operações de vigilância entomológica e incluindo a possibilidade de colocar foto e GPS. Este é o mesmo formulário preenchido durante o atendimento de uma denúncia.
                        </p>
                        
                        <p style={{marginTop: '1rem'}}><strong>Campos detalhados do formulário:</strong></p>
                        
                        <div style={{ fontSize: '0.9rem', color: '#444' }}>
                            <p><strong>1. Dados da Atividade:</strong> Tipo de Atividade (Pesquisa, Borrifação, Atendimento ao PIT), Data da Atividade e Número do PIT.</p>
                            <p><strong>2. Dados do Domicílio:</strong> Nome, Código e Categoria da Localidade, Endereço, Número e Complemento.</p>
                            <p><strong>3. Detalhes do Domicílio:</strong> Pendência da Pesquisa/Borrifação, Nome do Morador, Número Anexo, Situação do Imóvel, Tipo de Parede, Tipo de Teto e Melhoria Habitacional.</p>
                            <p><strong>4. Captura de Triatomíneos:</strong> Registro de capturas no Intradomicílio e Peridomicílio, incluindo vestígios encontrados e número de barbeiros capturados.</p>
                            <p><strong>5. Borrifação:</strong> Nome do Inseticida utilizado e Número de Cargas aplicadas.</p>
                            <p><strong>6. Código de Etiqueta:</strong> Registro numérico da etiqueta física.</p>
                            <p><strong>7. Fotos:</strong> Espaço para anexar até 4 fotografias do inseto ou ambiente.</p>
                            <p><strong>8. Agente Responsável:</strong> Nome do agente que realizou a visita (preenchido automaticamente).</p>
                        </div>

                        <div className="manual-important-box" style={{marginTop: '1.5rem'}}>
                            📍 <strong>GPS:</strong> O formulário inclui o registro automático da localização geográfica. Lembre-se sempre de obter a localização no campo <strong>Dados do Domicílio</strong>.
                        </div>
                    </div>
                    <div className="manual-image-content">
                        <div className="manual-image-grid">
                            <img src={registro1} alt="Registro Proativo 1" className="grid-screenshot" />
                            <img src={registro2} alt="Registro Proativo 2" className="grid-screenshot" />
                            <img src={atender1} alt="Mesmo formulário 1" className="grid-screenshot" />
                            <img src={atender2} alt="Mesmo formulário 2" className="grid-screenshot" />
                        </div>
                    </div>
                </div>

                {/* SEÇÃO 5: HISTÓRICO E MAPA */}
                <div className="manual-section-row">
                    <div className="manual-text-content">
                        <h2 className="manual-section-title">5. Histórico e Mapa da Área</h2>
                        <p>
                            A seção <strong>Meu Histórico de Trabalho</strong> funciona como um histórico completo, onde o agente pode consultar todos os formulários realizados em campo, permitindo revisões ou alterações em registros salvos quando necessário.
                        </p>
                        <p style={{marginTop: '1rem'}}>
                            Complementarmente, o <strong>Mapa da Área</strong> oferece uma visualização geográfica do município, onde é possível identificar rapidamente a localização exata de focos de triatomíneos e endereços das denúncias (pendentes ou atendidas).
                        </p>
                    </div>
                    <div className="manual-image-content">
                        <div className="manual-image-triangle">
                            <div className="triangle-top">
                                <img src={historico} alt="Histórico" className="grid-screenshot" />
                            </div>
                            <div className="triangle-bottom">
                                <img src={mapa} alt="Mapa 1" className="grid-screenshot" />
                                <img src={mapa2} alt="Mapa 2" className="grid-screenshot" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* SEÇÃO 6: PERFIL E PERMISSÕES */}
                <div className="manual-section-row reverse">
                    <div className="manual-text-content">
                        <h2 className="manual-section-title">6. Perfil do Agente e Permissões</h2>
                        <p>Na tela de perfil, o agente tem controle sobre as <strong>Permissões do Dispositivo</strong> necessárias para o funcionamento do aplicativo:</p>
                        <ul className="manual-list">
                            <li><strong>Localização:</strong> Para capturar automaticamente as coordenadas das ocorrências.</li>
                            <li><strong>Câmera:</strong> Para o registro de fotos nos formulários de campo.</li>
                            <li><strong>Armazenamento:</strong> Para o armazenamento temporário que permite guardar os registros feitos em modo offline.</li>
                        </ul>
                        <p>Além disso, o agente tem acesso às <a href="https://vectortrackers.com/politica-de-privacidade" target="_blank" rel="noopener noreferrer" style={{ color: '#00AEEF', fontWeight: 'bold', textDecoration: 'underline' }}>Políticas de Privacidade</a>.</p>
                        
                        <div className="manual-important-box" style={{marginTop: '1.5rem'}}>
                            💬 <strong>Relatar um Problema:</strong> Existe uma aba específica para reportar erros ou sugestões. Como estamos em desenvolvimento, seu feedback nos ajuda muito a melhorar a ferramenta!
                        </div>
                    </div>
                    <div className="manual-image-content">
                        <div className="manual-image-grid">
                            <img src={telaPerfil} alt="Perfil do Agente" className="grid-screenshot" />
                            <img src={permissoes} alt="Permissões" className="grid-screenshot" />
                        </div>
                    </div>
                </div>

                {/* SEÇÃO: SOBRE O PAINEL WEB */}
                <div id="sobre-painel-web-sec" className="manual-main-section-title" style={{ marginTop: '6rem' }}>
                    <h2>SOBRE O PAINEL WEB</h2>
                    <div className="title-underline"></div>
                </div>

                {/* SEÇÃO 7: GESTÃO ADMINISTRATIVA */}
                <div className="manual-section-column">
                    <div className="manual-text-content">
                        <h2 className="manual-section-title">7. Gestão Administrativa no Painel Web</h2>
                        <p>O Painel Web é a ferramenta central de gestão de campo.</p>
                        <ul className="manual-list">
                            <li><strong>Gestão de Agentes:</strong> Criação e edição de contas de Agentes de Combate às Endemias (ACE).</li>
                            <li><strong>Monitoramento em Tempo Real:</strong> Acompanhamento geográfico de todas as vistorias e registros proativos realizados.</li>
                            <li><strong>Análise de Dados:</strong> Visualização e exportação de formulários de campo para os sistemas oficiais.</li>
                        </ul>
                        <div className="manual-important-box" style={{ marginTop: '2rem' }}>
                            <strong>Nota:</strong> Entre em contato em caso de dúvida sobre o login do painel:<br/>
                            📧 <a href="mailto:contato@vectortrackers.com" style={{ color: '#00AEEF', fontWeight: 'bold' }}>contato@vectortrackers.com</a><br/>
                            📞 <strong>(86) 98157-4244</strong>
                        </div>
                    </div>
                    <div className="manual-image-content-column">
                        <img src={loginPainelWeb} alt="Login Painel Web" className="grid-screenshot full-width-image" />
                        <div style={{ textAlign: 'center', marginTop: '10px' }}>
                            <a 
                                href="https://painel.vectortrackers.com/" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                style={{ color: '#00AEEF', fontWeight: 'bold', fontSize: '1rem', textDecoration: 'underline' }}
                            >
                                painel.vectortrackers.com
                            </a>
                        </div>
                    </div>
                </div>

                {/* SEÇÃO 8: GERENCIAMENTO DE AGENTES */}
                <div className="manual-section-column">
                    <div className="manual-text-content">
                        <h2 className="manual-section-title">8. Gerenciamento de Agentes</h2>
                        <p>
                            Na aba <strong>Gerenciamento</strong>, o administrador pode cadastrar os agentes para que eles tenham acesso ao aplicativo Vector Tracker.
                        </p>
                        <ul className="manual-list" style={{ marginTop: '1rem' }}>
                            <li><strong>Cadastro de Acesso:</strong> O login pode ser criado utilizando a preferência do agente, como <strong>e-mail, número de telefone ou CPF</strong>.</li>
                            <li><strong>Informações Necessárias:</strong> É obrigatório inserir o nome completo do agente e definir uma senha inicial de <strong>no mínimo 6 dígitos</strong>.</li>
                            <li><strong>Edição e Controle:</strong> É possível editar as informações dos agentes a qualquer momento.</li>
                            <li><strong>Desativação de Contas:</strong> Caso um agente deixe a equipe, utilize a opção <strong>Desativar</strong>. </li>
                        </ul>
                        <div className="manual-important-box" style={{ marginTop: '1.5rem' }}>
                            <strong>⚠️ Segurança de Dados:</strong> O sistema não possui a opção de "Excluir" agentes. Isso é uma medida de segurança para garantir que todos os registros e formulários realizados por aquele profissional permaneçam preservados no banco de dados para fins de histórico e auditoria.
                        </div>
                    </div>
                    <div className="manual-image-content-column">
                        <img src={gerenciamentoPainel} alt="Gerenciamento de Agentes" className="grid-screenshot full-width-image" />
                    </div>
                </div>

                {/* SEÇÃO 9: VIGILÂNCIA ENTOMOLÓGICA */}
                <div className="manual-section-column">
                    <div className="manual-text-content">
                        <h2 className="manual-section-title">9. Vigilância Entomológica e Sincronização</h2>
                        <p>
                            Na aba <strong>Vigilância Entomológica</strong>, o digitador pode visualizar todos os formulários de campo realizados tanto pelo aplicativo quanto diretamente pelo painel, além de cadastrar novos registros proativos se necessário.
                        </p>
                        
                        <div className="manual-important-box" style={{ marginTop: '1rem' }}>
                            <strong>🔄 Sincronização com Sistemas Oficiais:</strong>
                            <p style={{ marginTop: '0.5rem' }}>Nosso sistema não sincroniza automaticamente os formulários de campo com os sistemas oficiais de registro. Por isso, todos os novos registros são salvos inicialmente com o status <strong>PENDENTE</strong>.</p>
                        </div>

                        <ul className="manual-list">
                            <li><strong>Processar Registros:</strong> Ao clicar em <strong>Processar</strong> na coluna de status, você será redirecionado para a tela de "Processar Formulário de Campo".</li>
                            <li><strong>Papel do Digitador:</strong> Nesta tela, o responsável pela digitação visualiza todas as informações técnicas para transferi-las manualmente ao sistema oficial.</li>
                            <li><strong>Concluir e Sincronizar:</strong> Após finalizar a inserção nos sistemas oficiais, deve-se clicar em <strong>Concluir e Sincronizar</strong>.</li>
                            <li><strong>Status Final:</strong> Após essa ação, a ficha passa a ter o status <strong>SINCRONIZADO</strong> em nosso sistema, indicando que o trabalho foi devidamente processado.</li>
                        </ul>
                    </div>
                    <div className="manual-image-content-column">
                        <img src={vigilanciaEnto} alt="Vigilância Entomológica" className="grid-screenshot full-width-image" style={{marginBottom: '20px'}} />
                        <img src={processarFicha} alt="Processar Formulário" className="grid-screenshot full-width-image" />
                    </div>
                </div>

                {/* SEÇÃO 10: CADASTRO DE EXAMES */}
                <div className="manual-section-column">
                    <div className="manual-text-content">
                        <h2 className="manual-section-title">10. Cadastro de Exames (Laudos)</h2>
                        <p>
                            Para todos os formulários que possuem uma etiqueta vinculada, é possível realizar o cadastro dos resultados dos exames laboratoriais no painel.
                        </p>
                        
                        <ul className="manual-list" style={{ marginTop: '1rem' }}>
                            <li><strong>Botão Cadastrar:</strong> Na aba de Vigilância Entomológica, localize o botão <strong>Cadastrar</strong> na coluna de <strong>Ação</strong>. Esta opção fica disponível para todos os formulários que possuem código de etiqueta.</li>
                            <li><strong>Formulário de Laudo:</strong> Ao clicar, um modal será aberto para o preenchimento das informações do laboratório.</li>
                            <li><strong>Dados do Exame:</strong> Insira o nome do técnico responsável, a data em que o exame foi realizado e a situação atual (Finalizado ou Pendente).</li>
                            <li><strong>Registro de Exemplares:</strong> Você pode adicionar múltiplos exemplares ao laudo, informando a espécie do vetor, o local de captura (Intra ou Peridomicílio), o estágio evolutivo e o resultado do exame (Positivo ou Negativo).</li>
                        </ul>
                    </div>
                    <div className="manual-image-content-column">
                        <img src={cadastrarExame} alt="Botão Cadastrar Exame" className="grid-screenshot full-width-image" style={{marginBottom: '20px'}} />
                        <img src={modalExame} alt="Modal de Cadastro de Exame" className="grid-screenshot full-width-image" />
                    </div>
                </div>

                {/* SEÇÃO 11: MAPA DE VIGILÂNCIA */}
                <div className="manual-section-column">
                    <div className="manual-text-content">
                        <h2 className="manual-section-title">11. Mapa de Vigilância</h2>
                        <p>
                            A aba <strong>Mapa de Vigilância</strong> oferece uma visão geográfica do município.
                        </p>
                        
                        <ul className="manual-list" style={{ marginTop: '1rem' }}>
                            <li><strong>Visão Geral e Lista Lateral:</strong> À esquerda, você encontra uma lista de todos os registros (Denúncias e Visitas Técnicas), facilitando a navegação rápida.</li>
                            <li><strong>Identificação Visual:</strong> O mapa utiliza marcadores coloridos para facilitar a triagem visual rápida.</li>
                            <li><strong>Detalhes da Visita:</strong> Ao clicar em qualquer marcador ou item da lista, um painel detalhado é exibido com:
                                <ul>
                                    <li>Informações de denúncias da comunidade.</li>
                                    <li>Visita Técnica do Agente.</li>
                                    <li>Resultados Laboratoriais.</li>
                                    <li>Fotos: Fotos reais registradas durante o trabalho de campo.</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div className="manual-image-content-column">
                        <img src={mapaVigilancia} alt="Mapa de Vigilância" className="grid-screenshot full-width-image" />
                    </div>
                </div>

            </div>

            <footer className="landing-footer">
                <div className="footer-content">
                    <div className="footer-brand">
                        <img src={logo} alt="Vector Tracker Logo" className="footer-logo" />
                        <span>Vector Tracker</span>
                    </div>
                    <div className="footer-links">
                        <h4>Políticas</h4>
                        <Link to="/politica-de-privacidade">Política de Privacidade</Link>
                        <Link to="/manual-de-uso">Manual de Uso</Link>
                    </div>
                </div>
                <div className="footer-separator"></div>
                <div className="footer-bottom">
                    <p>VECTOR TRACKER SOLUCOES DIGITAIS INOVA SIMPLES (I.S.) | 64.785.501/0001-03</p>
                    <p>© 2026 Vector Tracker</p>
                </div>
            </footer>
        </div>
    );
};

export default ManualUso;
